module.exports = __webpack_public_path__ + "static/media/as.9ab79f21.svg";